import { useContext } from 'react';
import { NotesDispatchContext } from '@/state/NotesContext';

export function useNotesDispatch() {
  return useContext(NotesDispatchContext);
}
